export default "__VITE_ASSET__c83bfaf1__"